// Typed client for the transeu-auth edge function (Trans.eu connection, #375).
//
// Wraps the two actions the settings card invokes:
//   status      → connection status + "connected as …" company + private exchanges
//   connect_url → the Trans.eu authorize URL the browser is sent to
//
// All methods either return a typed success payload or throw (the thrown Error
// carries `.code`, e.g. TRANSEU_NOT_CONFIGURED).

import { BaseEdgeFnClient } from './BaseEdgeFnClient.ts';
import type { SupabaseClient } from '../base.ts';
import type { TranseuAccountOverview } from '../transeu/TranseuAccountService.ts';
import type { TranseuCallbackReason } from '../transeu/TranseuAuthService.ts';

export type { TranseuAccountOverview, TranseuCallbackReason };

const FN = 'transeu-auth';

export interface TranseuStatus extends TranseuAccountOverview {
  /** False when the Trans.eu credentials / encryption key are not set on this env. */
  configured: boolean;
}

export class TranseuEdgeFnClient extends BaseEdgeFnClient {
  constructor(sb: SupabaseClient) {
    super(sb);
  }

  async status(): Promise<TranseuStatus> {
    return this.callOrThrow<TranseuStatus>(FN, { action: 'status' });
  }

  async connectUrl(): Promise<string> {
    const { authorizeUrl } = await this.callOrThrow<{ authorizeUrl: string }>(FN, { action: 'connect_url' });
    return authorizeUrl;
  }
}
